import { gql } from "@apollo/client";

export const GET_STRIPE_CHECKOUT_SESSION = gql`
  query getStripeCheckout($planId: String!, $isProd: Boolean!) {
    getStripeCheckout(planId: $planId, isProd: $isProd) {
      url
    }
  }
`;
